import { render, staticRenderFns } from "./ProfessionalDetailsAsAssistant.vue?vue&type=template&id=f1b10a8c&scoped=true"
import script from "./ProfessionalDetailsAsAssistant.vue?vue&type=script&lang=js"
export * from "./ProfessionalDetailsAsAssistant.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalDetailsAsAssistant.vue?vue&type=style&index=0&id=f1b10a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b10a8c",
  null
  
)

export default component.exports